import React from 'react';
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import LabelColorPicker from '../components/LabelColorPicker';
import { Label } from '../../../../../../../common/labels/labelTypes';

type Props = {
    label: Label;
    showColorMenu: boolean;
};

const LabelColorPopup: React.FC<Props> = ({ label, showColorMenu }) => {
    return (
        <div className="LabelColorPopup">
            <FloatingPanel
                className="light !w-auto"
                selector={`#label-color-${label.id}`}
                pollPosition
                offset={20}
                showArrow={false}
                distance={0}
                alignment={TooltipAlignment.START}
                position={TooltipPositions.RIGHT}
                show={showColorMenu}
            >
                <PopupPanelMouseManager
                    visible={showColorMenu}
                    popupId={PopupIds.LABEL_EDIT_COLOR}
                    closePopup={() => {}}
                >
                    <div className="mb-3 mt-3">
                        <LabelColorPicker label={label} />
                    </div>
                </PopupPanelMouseManager>
            </FloatingPanel>
        </div>
    );
};

export default LabelColorPopup;
